import { z } from 'zod'
import { createExpenseBaseSchema, sameSignRefinement, sameSignError } from './create-expense.schema'

export const updateExpenseSchema = createExpenseBaseSchema
  .partial()
  .extend({
    groupId: z.string().guid().nullable().optional(),
    // on update an omitted date must leave the stored date unchanged. the base schema defaults
    // date to now (correct for create), and .partial() keeps that default — so a PATCH without a
    // date would silently move the expense to today. override it to a plain optional with no default.
    date: z.string().datetime({ offset: true }).optional(),
  })
  .refine(sameSignRefinement, sameSignError)

export type UpdateExpenseDto = z.infer<typeof updateExpenseSchema>
